export default "__VITE_ASSET__b218018a__"